"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var CoverPanelWidget = exports.CoverPanelWidget = /** @class */ (function (_super) {
    __extends(CoverPanelWidget, _super);
    function CoverPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateNext = function () {
            _this.props.engine.navigate(_this.getSetting("quotePageId"), false);
        };
        return _this;
    }
    CoverPanelWidget.prototype.render = function () {
        var premiumType = this.props.interaction.factors.premiumType;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-mobile-none" },
                React.createElement("div", { className: "section-panel your-cover-panel pb-3 d-flex" },
                    React.createElement("img", { className: "main-icon policy-icon home-product", src: "/".concat(services_1.resourcesHelper.THEME, "/img/policy-summary.png"), alt: "Home cover icon" }),
                    React.createElement("div", { className: "section" },
                        React.createElement("h2", { className: "text-center mb-3 policy-heading" }, "Policy details"),
                        React.createElement("div", { className: "section-contents" }, this.renderCoverDetails(premiumType)),
                        React.createElement("h2", { className: "text-center mt-4 mb-3 excess-heading" }, "Excesses"),
                        React.createElement("div", { className: "section-contents mt-2" }, this.renderExcesses()),
                        React.createElement("div", { className: "section-contents" }, this.renderEditButton())),
                    this.renderPrice(premiumType))),
            React.createElement("div", { className: "d-desktop-none" },
                React.createElement("div", { className: "section-panel your-cover-panel pb-3 d-flex" },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", { className: "mr-auto" },
                            React.createElement("img", { className: "main-icon policy-icon home-product", src: "/".concat(services_1.resourcesHelper.THEME, "/img/policy-summary.png"), alt: "Home cover icon" })),
                        this.renderPrice(premiumType)),
                    React.createElement("div", { className: "section" },
                        React.createElement("h2", { className: "text-center mb-3 policy-heading" }, "Policy details"),
                        React.createElement("div", { className: "section-contents" }, this.renderCoverDetails(premiumType)),
                        React.createElement("h2", { className: "text-center mt-4 mb-3 excess-heading" }, "Excesses"),
                        React.createElement("div", { className: "section-contents mt-2" }, this.renderExcesses()),
                        React.createElement("div", { className: "section-contents" }, this.renderEditButton()))))));
    };
    CoverPanelWidget.prototype.renderCoverDetails = function (premiumType) {
        var headerInfo = this.props.interaction.headerInfo;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Cover start date:"),
                React.createElement("div", { className: "detail-value", id: "cover-startDate" }, (0, commonFunctions_1.renderCoverStartDate)(headerInfo.startDate))),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Cover end date:"),
                React.createElement("div", { className: "detail-value", id: "cover-endDate" }, (0, commonFunctions_1.convertDateTime)(headerInfo.endDate))),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Cover type:"),
                React.createElement("div", { className: "detail-value", id: "cover-type" }, "Buildings and contents")),
            React.createElement("div", { className: "detail font-weight-light" },
                React.createElement("div", { className: "padding-left-right-10" }, premiumType === services_1.PREMIUM_TYPE_ANNUAL ? '* Incl. insurance premium tax' : '* Incl. interest and insurance premium tax'))));
    };
    CoverPanelWidget.prototype.renderExcesses = function () {
        var subsidenceLandslipOrHeave = this.props.interaction.annualHomeExcesses.subsidence;
        var escapeOfWater = this.props.interaction.annualHomeExcesses.escapeOfWater;
        var flood = this.props.interaction.annualHomeExcesses.flood;
        var allOtherClaims = this.props.interaction.annualHomeExcesses.allOtherClaims;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detail" },
                React.createElement("span", null, "Subsidence, landslip or heave:"),
                React.createElement("span", { className: "ml-2 font-weight-bold", id: "subsidence-landslip-heave" }, (0, commonFunctions_1.getAmountToDisplay)(subsidenceLandslipOrHeave))),
            React.createElement("div", { className: "detail" },
                React.createElement("span", null, "Escape of water:"),
                React.createElement("span", { className: "ml-2 font-weight-bold", id: "escape-of-water" }, (0, commonFunctions_1.getAmountToDisplay)(escapeOfWater))),
            React.createElement("div", { className: "detail" },
                React.createElement("span", null, "Flood:"),
                React.createElement("span", { className: "ml-2 font-weight-bold", id: "flood" }, (0, commonFunctions_1.getAmountToDisplay)(flood))),
            React.createElement("div", { className: "detail" },
                React.createElement("span", null, "All other claims:"),
                React.createElement("span", { className: "ml-2 font-weight-bold", id: "all-other-claims" }, (0, commonFunctions_1.getAmountToDisplay)(allOtherClaims)))));
    };
    CoverPanelWidget.prototype.renderEditButton = function () {
        return (React.createElement("div", null,
            React.createElement("button", { className: "mb-2 mt-40 btn btn-primary btn-edit-cover-details", id: "".concat(this.props.question.name), onClick: this.navigateNext }, "Edit policy details")));
    };
    CoverPanelWidget.prototype.renderPrice = function (premiumType) {
        var _a;
        var price = premiumType === services_1.PREMIUM_TYPE_ANNUAL ? this.props.interaction.factors.annualPremium : this.props.interaction.factors.monthlyPremium;
        var totalPaid = (_a = this.props.interaction.paymentDetails.instalmentPlan) === null || _a === void 0 ? void 0 : _a.totalAmount;
        var marginLeft = premiumType === services_1.PREMIUM_TYPE_ANNUAL ? "ml-annual" : "ml-monthly";
        return (React.createElement("div", { className: "fs-16 text-align-right ".concat(marginLeft) },
            price > 0 &&
                React.createElement("div", { className: "font-weight-bold line-adjustment" },
                    React.createElement("span", null, "Price"),
                    React.createElement("span", { className: "lh-32" },
                        React.createElement("span", { className: "fs-28 vertical-align-middle" }, " ".concat((0, commonFunctions_1.getAmountToDisplay)(price))),
                        ' ',
                        React.createElement("span", null, "/ ".concat(premiumType === services_1.PREMIUM_TYPE_ANNUAL ? "year*" : "month*")))),
            premiumType !== services_1.PREMIUM_TYPE_ANNUAL &&
                React.createElement("div", { className: "font-weight-extra-light d-flex justify-content-end" },
                    "You pay",
                    ' ',
                    React.createElement("span", { className: "font-weight-bold ml-2" }, (0, commonFunctions_1.getAmountToDisplay)(totalPaid)),
                    ' ',
                    React.createElement("span", { className: "ml-2" }, "in total"))));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CoverPanelWidget.prototype, "changelogRecorder", void 0);
    CoverPanelWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "quotePageId", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CoverPanelWidget);
    return CoverPanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CoverPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/CoverPanelWidget.js
// module id = 3688
// module chunks = 0